import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {CatalogDto} from "../catalog.dto";

export class SearchCatalogRes extends SearchResultDto {

  public override readonly items: SearchCatalogItem[] = [];

  constructor(init?: Partial<SearchCatalogRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchCatalogItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchCatalogItem extends CatalogDto implements SearchItem {

  public override readonly id!: string;
  public readonly articleCount: number | undefined;

  constructor(init?: Partial<SearchCatalogItem>) {
    super(init);
    Object.assign(this, init);
  }
}
